(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mixed-order"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-mixed-order]:not([data-initialized])').forEach((root) => {
    root.dataset.initialized = 'true';
    const variants = JSON.parse(root.dataset.variants);
    const lines = root.querySelector('[data-lines]');
    const template = root.querySelector('[data-row-template]');
    const money = new Intl.NumberFormat(undefined, { style: 'currency', currency: root.dataset.currency });
    const message = root.querySelector('[data-message]');
    const submit = root.querySelector('[data-submit]');

    const updateSummary = () => {
      let count = 0;
      let subtotal = 0;
      lines.querySelectorAll('[data-row]').forEach((row) => {
        const quantityValue = Number(row.querySelector('[data-quantity]').value);
        const quantity = Number.isInteger(quantityValue) && quantityValue > 0 ? quantityValue : 0;
        const variantId = row.dataset.variantId;
        const variant = variants.find((item) => String(item.id) === variantId);
        if (variant && quantity > 0) {
          count += quantity;
          subtotal += variant.price * quantity;
        }
      });
      root.querySelector('[data-item-count]').textContent = count ? `${count} ${count === 1 ? root.dataset.itemLabel : root.dataset.itemsLabel}` : '';
      root.querySelector('[data-subtotal]').textContent = count ? `${root.dataset.subtotalLabel} ${money.format(subtotal / 100)}` : '';
    };

    const updateRow = (row) => {
      const model = row.querySelector('[data-model]').value;
      const color = row.querySelector('[data-color]').value;
      const variant = variants.find((item) => item.option1 === model && item.option2 === color);
      const unitPrice = row.querySelector('[data-unit-price]');
      const rowError = row.querySelector('[data-row-error]');
      row.dataset.variantId = variant && variant.available ? String(variant.id) : '';
      unitPrice.textContent = variant ? money.format(variant.price / 100) : '';
      rowError.textContent = variant && !variant.available ? root.dataset.unavailableLabel : '';
      updateSummary();
    };

    const addRow = () => {
      const row = template.content.firstElementChild.cloneNode(true);
      row.querySelector('[data-model]').addEventListener('change', () => updateRow(row));
      row.querySelector('[data-color]').addEventListener('change', () => updateRow(row));
      row.querySelector('[data-quantity]').addEventListener('input', updateSummary);
      row.querySelector('[data-remove]').addEventListener('click', () => {
        row.remove();
        if (!lines.children.length) addRow();
        updateSummary();
      });
      lines.appendChild(row);
      updateSummary();
    };

    addRow();
    root.querySelector('[data-add-line]').addEventListener('click', addRow);
    submit.addEventListener('click', async () => {
      message.textContent = '';
      const items = new Map();
      let incomplete = false;
      let unavailable = false;
      lines.querySelectorAll('[data-row]').forEach((row) => {
        const model = row.querySelector('[data-model]').value;
        const color = row.querySelector('[data-color]').value;
        const quantity = Number(row.querySelector('[data-quantity]').value);
        if (!model && !color) return;
        if (!model || !color || !Number.isInteger(quantity) || quantity < 1) {
          incomplete = true;
          return;
        }
        const variant = variants.find((item) => item.option1 === model && item.option2 === color);
        if (!variant || !variant.available) {
          unavailable = true;
          return;
        }
        items.set(variant.id, (items.get(variant.id) || 0) + quantity);
      });
      if (incomplete) {
        message.textContent = root.dataset.incompleteLabel;
        return;
      }
      if (unavailable) {
        message.textContent = root.dataset.unavailableLabel;
        return;
      }
      if (!items.size) {
        message.textContent = root.dataset.incompleteLabel;
        return;
      }
      submit.disabled = true;
      submit.textContent = root.dataset.addingLabel;
      try {
        const response = await fetch(root.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: Array.from(items, ([id, quantity]) => ({ id, quantity })) })
        });
        if (!response.ok) throw new Error('cart_add_failed');
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        message.textContent = root.dataset.cartErrorLabel;
        submit.disabled = false;
        submit.textContent = root.dataset.addToCartLabel;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
